export const timerTypes = [
  // 1-- 工作， 2--吃饭， 3--娱乐， 4--睡觉
  {label: '工作', value: 1},
  {label: '吃饭', value: 2},
  {label: '娱乐', value: 3},
  {label: '睡觉', value: 4},
  {label: '学习', value: 5},
  {label: '阅读', value: 6},
  {label: '例行', value: 7},
  {label: '项目', value: 8},
  {label: '健身', value: 9},
]

export const timerTypeMap = {
  '1': '工作',
  '2': '吃饭',
  '3': '娱乐',
  '4': '睡觉',
  '5': '学习',
  '6': '阅读',
  '7': '例行',
  '8': '项目',
  '9': '健身',
  '9999': '未知'
}

export const timerTypeList = ['工作', '吃饭', '娱乐', '睡觉', '学习', '阅读', '例行', '项目', '健身', '未知',]
